import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { DocumentViewer } from './DocumentViewer';

interface DocumentPreviewDialogProps {
  documentId: string;
  fileName: string;
  /** Closing unmounts the viewer, which aborts a fetch in progress */
  onClose: () => void;
  page?: number;
  jump?: number;
}

/** A document's preview over the current page (#29). Render it only while it should be open */
export const DocumentPreviewDialog: React.FC<DocumentPreviewDialogProps> = ({ documentId, fileName, onClose, page, jump }) => {
  // No Dialog.Trigger opens this one, so Radix has nowhere to return focus and it would fall to the
  // body, sending a keyboard user back to the top of the page
  const [opener] = useState(() => document.activeElement);

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className="flex h-[90vh] w-[calc(100vw-2rem)] max-w-5xl flex-col gap-3 p-4"
        data-testid="document-preview-dialog"
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          if (opener instanceof HTMLElement) opener.focus();
        }}
      >
        <DialogTitle className="pr-8 text-base break-all">{fileName}</DialogTitle>
        <DialogDescription className="sr-only">Preview of the document</DialogDescription>
        <DocumentViewer documentId={documentId} fileName={fileName} page={page} jump={jump} className="flex-1" />
      </DialogContent>
    </Dialog>
  );
};
